const optionsData = [
  {
    title: 'Sponsorship Noticias TNO',
    annualPrice: 'Trimestral: 800',
    monthlyPrice: 300,
    features: [
      'Mención en Presentación y Despedida (Voz: Sol Vargas)',
      'Transmisión TOTALMENTE EN VIVO',
      'Estreno: Viernes 5:00 PM por TNO Network',
      'Repeticiones: Sábado, Domingo y Lunes (Mañana)',
      'Presencia en Web, App y Redes Sociales',
    ],
    idealFor: 'Marcas líderes que buscan asociarse con el prestigio y la seriedad informativa en tiempo real.',
    duration: 'Mensual',
    buttonText: 'Patrocinar Noticiero',
    highlightedTitle: 'Presencia Multiplataforma',
    highlightedContent: [
      'Tu marca viaja con la voz más reconocida del periodismo.',
      'Cuatro transmisiones semanales para máxima recordación.',
      'Presencia en el centro de la conversación nacional e internacional.',
    ],
    highlightedButtonText: 'Ver Demo del Programa',
  },
  {
    title: 'Plan Rotativa TNO',
    annualPrice: 'Trimestral: 800',
    monthlyPrice: 300,
    features: [
      'Cuñas rotativas cada 15 minutos',
      'Presencia garantizada en la rotativa radial CADA HORA',
      'Transmisión ininterrumpida las 24 horas',
      'Impacto en Web y todas las plataformas digitales',
      'Ubicación preferencial en cortes comerciales',
    ],
    idealFor: 'Marcas que requieren alta frecuencia, repetición constante y presencia horaria garantizada.',
    duration: 'Mensual',
    buttonText: 'Iniciar Rotación',
    highlightedTitle: 'Impacto Ininterrumpido',
    highlightedContent: [
      '96 impactos diarios garantizados en la red.',
      'Presencia horaria fija que domina el hábito del oyente.',
      'Frecuencia diseñada para dominar el "Top of Mind" del consumidor.',
    ],
    highlightedButtonText: 'Consultar Disponibilidad',
  },
  {
    title: 'Exclusive Segment Sponsor',
    annualPrice: 'Trimestral: 400',
    monthlyPrice: 150,
    features: [
      'Mención exclusiva: "Sección presentada por..."',
      'Logo animado permanente durante el segmento',
      'Disponible en: Entérate, Muévete, Emociónate o Actualízate',
      'Vinculación directa con el ADN de tu marca',
    ],
    idealFor: 'Marcas especializadas (Tecnología, Salud, Deporte) que buscan relevancia temática.',
    duration: 'Suscripción Mensual',
    buttonText: 'Elegir mi Sección',
    highlightedTitle: 'Autoridad de Nicho',
    highlightedContent: [
      'Tu marca se convierte en el referente de la categoría.',
      'Asociación orgánica: no eres una interrupción, eres el facilitador del contenido.',
      'Ideal para posicionar productos en contextos de alta afinidad.',
    ],
    highlightedButtonText: 'Ver Secciones Disponibles',
  },
  {
    title: 'Business Interview Spotlight',
    annualPrice: 'Pack 3 Entrevistas: 250',
    monthlyPrice: 100,
    features: [
      'Entrevista de 5 a 7 minutos en vivo',
      'Conducido por Sol Vargas en el set principal',
      'Análisis de lanzamientos, hitos o innovaciones',
      'Entrega del clip editado para uso en RR.PP.',
    ],
    idealFor: 'CEOs, voceros corporativos y emprendedores que necesitan validar su liderazgo.',
    duration: 'Por sesión / Única',
    buttonText: 'Agendar Entrevista',
    highlightedTitle: 'Relaciones Públicas 360',
    highlightedContent: [
      'Eleva tu perfil profesional con el respaldo de Sol Vargas.',
      'Contenido de alto valor para tu LinkedIn y canales corporativos.',
      'Transforma un anuncio en una conversación de impacto nacional.',
    ],
    highlightedButtonText: 'Consultar Fechas',
  },
  {
    title: 'In-Situ Field Report',
    annualPrice: 'Pack Trimestral: 650',
    monthlyPrice: 250,
    features: [
      'Producción de reportaje de 3 min en tus instalaciones',
      'Equipo de prensa de TNO Media Lab desplegado',
      'Transmisión dentro del bloque informativo del viernes',
      'Narrativa periodística profesional',
    ],
    idealFor: 'Inauguraciones, plantas industriales, eventos masivos y lanzamientos de productos físicos.',
    duration: 'Por producción',
    buttonText: 'Solicitar Cobertura',
    highlightedTitle: 'Periodismo de Marca',
    highlightedContent: [
      'Muestra el corazón de tu empresa con estética broadcast.',
      'Tus clientes ven la realidad de tu negocio como una noticia relevante.',
      'Impacto visual que genera confianza y transparencia absoluta.',
    ],
    highlightedButtonText: 'Ver Ejemplos de Campo',
  },
  {
    title: 'Flash News Social Push',
    annualPrice: 'Pack 5 Flashes: 200',
    monthlyPrice: 50,
    features: [
      'Cápsula de 60 segundos con estética "Breaking News"',
      'Distribución prioritaria en Instagram y Web de TNO',
      'Anuncio de primicias, ofertas relámpago o eventos',
      'Locución profesional de impacto',
    ],
    idealFor: 'Promociones por tiempo limitado, anuncios urgentes o primicias de marca.',
    duration: 'Impacto Único',
    buttonText: 'Lanzar Noticia Flash',
    highlightedTitle: 'Atención Inmediata',
    highlightedContent: [
      'Aprovecha el sesgo de urgencia de la información real.',
      'Tu marca irrumpe en el scroll con la autoridad de una noticia urgente.',
      'Frecuencia y velocidad para resultados de corto plazo.',
    ],
    highlightedButtonText: 'Enviar mi Primicia',
  },
];

export default optionsData;
